import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, UntypedFormGroup } from '@angular/forms';

@Directive({
  selector: '[startEndTimeValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: StartEndTimeValidatorDirective, multi: true }]
})
export class StartEndTimeValidatorDirective implements Validator {

  validate(group: UntypedFormGroup): { [key: string]: any } | null {
    if (group.value && group.value.startTime != '' && group.value.endTime != '') {
      var today = new Date();
      var start = new Date(today.toLocaleDateString() + ' ' + group.value.startTime + ':00');
      var end = new Date(today.toLocaleDateString() + ' ' + group.value.endTime + ':00');
      
      if (start > end) {
        return { 'invalidTime': 'Start time cannot be greater than end time' };
      }
    }

    return null;
  }
}
